//CoolEarthCreate.jsx 

import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTree } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';
import Tooltip from '../../components/utils/Tooltip';
import { GenerateSugoCode } from '../../components/GenerateThink5whysCode';


const CoolEarthCreate = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { sugoId } = useParams();
  const mode = sugoId === undefined ? "add" : "update";
  const [sugo, setSugo] = useState(null);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState(null);
  const [startTime, setStartTime] = useState(false);
  const [countFormErrors, setCountFormErrors] = useState(0);

  const [autoSugoCode, setAutoSugoCode] = useState(GenerateSugoCode());

  const [formData, setFormData] = useState({
    userId: authState.user._id,
    title: "",
    description: "",
    sugoCategory: "",
    sugoCode: autoSugoCode,
    targetReduction: 100,
    targetStartDate: new Date(),
    targetEndDate: new Date(),
    dateCreated: new Date(),
    isActive: true,
    isDeleted: false,
    remarks: "",
  });
  // console.log("Mode is: ",mode);
  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/coolearth/mysugoforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {sugoId: sugoId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false }).then((data) => {
        // console.log("response for update - ",data.sugo);
        setSugo(data.sugo);
        setFormData({
          userId: data.sugo.userId,
          title: data.sugo.title,
          description: data.sugo.description,
          sugoCategory: data.sugo.sugoCategory,
          sugoCode: data.sugo.sugoCode,
          targetReduction: data.sugo.targetReduction,
          targetStartDate: data.sugo.targetStartDate,
          targetEndDate: data.sugo.targetEndDate,
          dateCreated: data.sugo.dateCreated,
          isActive: data.sugo.isActive,
          isDeleted: data.sugo.isDeleted,
          remarks: data.sugo.remarks,
        });
      })
      .catch((error) => {
        console.error("Error fetching SUGO data:", error);
        setError("Error fetching SUGO data");
      });
    }
  }, [mode, authState, sugoId, fetchData, setSugo]);

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      userId: sugo.userId,
      title: sugo.title,
      description: sugo.description,
      sugoCategory: sugo.sugoCategory,
      sugoCode: sugo.sugoCode,
      targetReduction: sugo.targetReduction,
      targetStartDate: sugo.targetStartDate,
      targetEndDate: sugo.targetEndDate,
      dateCreated: sugo.dateCreated,
      isActive: sugo.isActive,
      isDeleted: sugo.isDeleted,
      remarks: sugo.remarks,
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/coolearth", 
        method: "post",
        data: {formData: formData, userId: authState.user._id, dateCreated: new Date()}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);


      fetchData(config).then(() => {
        navigate("/coolearth-list");
      });
    }
    else {
      const config = { 
        url: `/coolearth/${sugoId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for coolearth update ",config);

      fetchData(config).then(() => {
        navigate("/coolearth-list");
      })
      .catch((error) => {
        console.error("Error updating SUGO:", error);
        setError("Error updating SUGO");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.sugoCategory) {
      errors.sugoCategory = "Please select a SUGO category";
    }
    if (!formData.targetStartDate) {
      errors.targetStartDate = "Start Date is required";
    }
    if (!formData.targetEndDate) {
      errors.targetEndDate = "End Date is required";
    } else if (new Date(formData.targetEndDate) < new Date(formData.targetStartDate)) {
      errors.targetEndDate = "End Date must be greater than Start Date";
    }
    if (!formData.title) {
      errors.title = "Title is required";
    } else if (formData.title.length > 100) {
      errors.title = "Title cannot exceed 100 characters";
    }
    if (!formData.description) {
      errors.description = "Description is required";
    } else if (formData.description.length > 1000) {
      errors.description = "Description cannot exceed 1000 characters";
    }
    if (!formData.targetReduction) {
      errors.targetReduction = "Reduction target is required";
    } else if (isNaN(formData.targetReduction) || Number(formData.targetReduction) <= 0) {
      errors.targetReduction = "Target reduction must be a positive number";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )
  return (
    <>
      <MainLayout>
        <div className='mt-12 m-auto my-2 p-2 border-2 shadow-md rounded-md w-full'>
            <h3 className='flex justify-center text-2xl mx-2 text-yellow-200'>CoolEarth - Sustainable Goal Create</h3>
            {loading ? (
              <Loader />
            ) : (
            <div className='text-m'>
              <div className='flex justify-center'>
                <h2 className="ml-2 text-xl text-white">{mode === "add" ? "Add New Sustainable Goal" : "Edit Sustainable Goal"}</h2>
              </div>
              <div className="px-4 py-4">
                <div className="mb-4 text-sm">
                    <p className="text-yellow-300">Your CoolEarth SUGO Code: {autoSugoCode}</p>
                </div>
                <div className="mb-4 text-sm">
                    <label htmlFor="sugoCategory">Select SUGO Category: </label>
                    <br />
                    <select name="sugoCategory" id="sugoCategory" value={formData.sugoCategory}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                      <option value="">Select Your SUGO Category</option>
                      <option value="Reduce-Reuse-Recycle">Reduce, Reuse, Recycle</option>
                      <option value="Conserve-Water">Conserve Water</option>   
                      <option value="Save-Energy">Save Energy</option>
                      <option value="Sustainable-Transportation">Sustainable Transportation</option>
                      <option value="Plant-Trees">Plant Trees</option>
                      <option value="Sustainable-Diet">Sustainable Diet</option>
                      <option value="Reduce-Plastic-Use">Reduce Plastic Use</option>   
                      <option value="Join-Environmental-Groups">Join Environmental Groups</option>
                      <option value="Community-Gardens">Community Gardens</option>   
                      <option value="Education-and-Awareness">Education and Awareness</option>
                      <option value="Green-Initiatives">Green Initiatives</option>
                      <option value="Sustainable-Events">Sustainable Events</option>
                      <option value="Eco-Friendly-Products">Eco-Friendly Products</option>
                      <option value="Support-Renewable-Energy">Support Renewable Energy</option> 
                      <option value="Advocate-for-Policies">Advocate for Policies</option>
                      <option value="Carbon-Footprint-Calculator">Carbon Footprint Calculator</option>
                      <option value="Using Green-Technologies">Using Green Technologies</option>                                                                     
                    </select>
                  </div>
                  <div className="mb-4 text-sm">
                    <label htmlFor="title">Title / Headline*:</label>
                    <br />
                    <input 
                      type="text" 
                      name="title" 
                      id="title" 
                      value={formData.title} 
                      placeholder="Enter the title..."
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("title")}
                  </div>
                  <div className="mb-4 text-sm">
                    <label htmlFor="description">Description*:</label>
                    <br/>
                    <textarea 
                      type="description" 
                      name="description" 
                      id="description" 
                      value={formData.description}
                      placeholder={showMicrophoneAlert ? "Write here or Click Mic for Voice Input...":"Write here.."}
                      onChange={handleChange}
                      maxLength="2000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("description")}
                  <div className="mb-4 text-sm">
                    <label htmlFor="targetStartDate">Target Start Date*:</label>
                    <br />
                    <DatePicker
                      selected={formData.targetStartDate}
                      onChange={date => setFormData({ ...formData, targetStartDate: date })}
                      dateFormat="dd/MM/yyyy"
                      id="targetStartDate"
                      name="targetStartDate"
                      className="form-control"
                    />
                    {fieldError("targetStartDate")}
                  </div>
                  <div className="mb-4 text-sm">
                    <label htmlFor="targetEndDate">Target End Date*:</label>
                    <br />
                    <DatePicker
                      selected={formData.targetEndDate}
                      onChange={date => setFormData({ ...formData, targetEndDate: date })}
                      dateFormat="dd/MM/yyyy"
                      id="targetEndDate"
                      name="targetEndDate"
                      className="form-control"
                    />
                    {fieldError("targetEndDate")}
                  </div>
                    <div className="mb-4 text-sm">
                      <label htmlFor="targetReduction">CO2 Reduction Target in Kg*:</label>
                      <br />
                      <input 
                        type="text" 
                        name="targetReduction" 
                        id="targetReduction" 
                        value={formData.targetReduction} 
                        placeholder="Enter the target..."
                        maxLength="100"
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '50px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("targetReduction")}
                    </div>
                  <div>
                </div>
              </div>
            </div>
            <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-center">
                    <button className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' onClick={handleSubmit}>{mode === "add" ? "Add New" : "Update"}</button>
                    <button className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' onClick={() => navigate("/coolearth-list")}>Cancel</button>
                    {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                  </div>
                </div>
          </div>
          )}
        </div>
      </MainLayout>
    </>
  )
}

export default CoolEarthCreate